// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2g-2";
export var placeholderIcon = "_2g-3";
export var thumbnailCanvas = "_2g-1";
export var thumbnailWrapper = "_2g-0";